<template>
  <div class="w-[96%] mx-auto" style="margin-top: 16px">
    <el-descriptions direction="vertical" :column="2" border>
      <el-descriptions-item label="医院">{{
        userInfo.hospital
      }}</el-descriptions-item>
      <el-descriptions-item label="科室">{{
        userInfo.keshi
      }}</el-descriptions-item>
      <el-descriptions-item label="姓名"
        >{{ userInfo.role }}--{{ userInfo.name }}</el-descriptions-item
      >
      <el-descriptions-item label="电话">
        <el-tag size="small">{{ userInfo.phone }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>

    <div class="flex justify-between" style="margin: 16px">
      <el-select
        v-model="rolevalue"
        placeholder="转换角色"
        style="width: 120px"
        @change="changerole"
      >
        <el-option
          v-for="item in rolesoptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <el-button
        type="primary"
        @click="startReferral"
        v-if="userInfo.role == '转诊医生'"
        >发起转诊</el-button
      >
      <el-button type="danger" @click="logout">退出登录</el-button>
    </div>

    <div style="margin: 16px" v-if="userInfo.role == '转诊医生'">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="转诊记录" name="referral">
          <div v-if="data.length === 0">
            <el-empty description="暂无转诊记录" />
          </div>
          <el-descriptions
            v-for="(item, index) in data"
            :key="index"
            border
            v-else
            direction="vertical"
            :column="2"
            style="margin-bottom: 20px"
          >
            <el-descriptions-item label="患者姓名">{{
              item.patientname
            }}</el-descriptions-item>

            <el-descriptions-item label="联系电话">
              <a :href="`tel:${item.patientphone}`">{{ item.patientphone }}</a>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="联系电话">{{
              item.patientphone
            }}</el-descriptions-item> -->
            <el-descriptions-item label="诊断信息">{{
              item.diagnosis.join(", ")
            }}</el-descriptions-item>
            <el-descriptions-item label="接诊医院">{{
              item.referralhospital
            }}</el-descriptions-item>
            <el-descriptions-item label="接诊科室">{{
              item.referraldepartment
            }}</el-descriptions-item>
            <el-descriptions-item label="接诊医生">{{
              item.referraldoctorName
            }}</el-descriptions-item>

            <el-descriptions-item label="接诊电话">
              <a :href="`tel:${item.referraldoctorPhone}`">{{
                item.referraldoctorPhone
              }}</a>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="接诊电话">{{
              item.referraldoctorPhone
            }}</el-descriptions-item> -->

            <el-descriptions-item label="医疗照片">
              <div v-if="item.medicalPhoto && item.medicalPhoto.length > 0">
                <el-image
                  v-for="(photo, photoIndex) in item.medicalPhoto"
                  :key="photoIndex"
                  :src="photo"
                  :preview-src-list="item.medicalPhoto"
                  style="width: 100px; height: 100px; margin-right: 10px"
                />
              </div>
              <span v-else>暂无医疗照片</span>
            </el-descriptions-item>

            <el-descriptions-item
              v-if="userInfo.name === item.referraldoctorName"
            >
              <el-button type="success" @click="confirmReferral(item)"
                >确认接诊</el-button
              >
              <el-button type="warning" @click="transferReferral(item)"
                >接诊转科</el-button
              >
              <el-button type="danger" @click="rejectReferral(item)"
                >拒绝接诊</el-button
              >
            </el-descriptions-item>
            <el-descriptions-item
              v-if="userInfo.name === item.name"
              label="处理状态"
            >
              <el-tag type="info">{{ item.status }}</el-tag>
            </el-descriptions-item>

            <el-descriptions-item
              label="拒绝原因"
              v-if="item.status === '已拒绝'"
            >
              {{ item.rejectReason }}
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="margin: 16px" v-if="userInfo.role == '接诊医生'">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="待接诊" name="pending">
          <div v-if="pendingData.length === 0">
            <el-empty description="暂无待接诊记录" />
          </div>

          <el-descriptions
            v-for="(item, index) in pendingData"
            :key="index"
            border
            v-else
            direction="vertical"
            :column="2"
            style="margin-bottom: 20px"
          >
            <el-descriptions-item label="患者姓名">{{
              item.patientname
            }}</el-descriptions-item>
            <!-- <el-descriptions-item label="患者电话">{{
              item.patientphone
            }}</el-descriptions-item> -->

            <el-descriptions-item label="患者电话">
              <a :href="`tel:${item.patientphone}`">{{ item.patientphone }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="诊断信息">{{
              item.diagnosis.join(", ")
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医院">{{
              item.hospital
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊科室">{{
              item.keshi
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医生">{{
              item.name
            }}</el-descriptions-item>

            <el-descriptions-item label="医生电话">
              <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="医生电话">{{
              item.phone
            }}</el-descriptions-item> -->

            <el-descriptions-item label="患者图片资料">
              <div v-if="item.medicalPhoto && item.medicalPhoto.length > 0">
                <el-image
                  v-for="(photo, photoIndex) in item.medicalPhoto"
                  :key="photoIndex"
                  :src="photo"
                  :preview-src-list="item.medicalPhoto"
                  style="width: 100px; height: 100px; margin-right: 10px"
                />
              </div>
              <span v-else>暂无患者图片资料</span>
            </el-descriptions-item>
            <el-descriptions-item
              v-if="userInfo.name === item.referraldoctorName"
              label="操作"
            >
              <el-button type="success" @click="confirmReferral(item)"
                >确认接诊</el-button
              >
              <el-button type="warning" @click="transferReferral(item)"
                >接诊转科</el-button
              >
              <el-button type="danger" @click="rejectReferral(item)"
                >拒绝接诊</el-button
              >
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.name === item.name">
              <el-tag type="info">已转诊</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="已接诊" name="accepted">
          <div v-if="acceptedData.length === 0">
            <el-empty description="暂无已接诊记录" />
          </div>
          <el-descriptions
            v-for="(item, index) in acceptedData"
            :key="index"
            border
            v-else
            direction="vertical"
            :column="2"
            style="margin-bottom: 20px"
          >
            <el-descriptions-item label="患者姓名">{{
              item.patientname
            }}</el-descriptions-item>
            <!-- <el-descriptions-item label="联系电话">{{
              item.patientphone
            }}</el-descriptions-item> -->

            <el-descriptions-item label="患者电话">
              <a :href="`tel:${item.patientphone}`">{{ item.patientphone }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="诊断信息">{{
              item.diagnosis.join(", ")
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医院">{{
              item.hospital
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊科室">{{
              item.keshi
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医生">{{
              item.name
            }}</el-descriptions-item>
            <el-descriptions-item label="医生电话">
              <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
            </el-descriptions-item>

            <el-descriptions-item label="患者图片资料">
              <div v-if="item.medicalPhoto && item.medicalPhoto.length > 0">
                <el-image
                  v-for="(photo, photoIndex) in item.medicalPhoto"
                  :key="photoIndex"
                  :src="photo"
                  :preview-src-list="item.medicalPhoto"
                  style="width: 100px; height: 100px; margin-right: 10px"
                />
              </div>
              <span v-else>暂无患者图片资料</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="已转科" name="transferred">
          <div v-if="transferredData.length === 0">
            <el-empty description="暂无已转科记录" />
          </div>
          <el-descriptions
            v-for="(item, index) in transferredData"
            :key="index"
            border
            v-else
            direction="vertical"
            :column="2"
            style="margin-bottom: 20px"
          >
            <el-descriptions-item label="患者姓名">{{
              item.patientname
            }}</el-descriptions-item>
            <el-descriptions-item label="患者电话">
              <a :href="`tel:${item.patientphone}`">{{ item.patientphone }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="诊断信息">{{
              item.diagnosis.join(", ")
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医院">{{
              item.hospital
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊科室">{{
              item.keshi
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医生">{{
              item.name
            }}</el-descriptions-item>
            <el-descriptions-item label="医生电话">
              <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
            </el-descriptions-item>

            <el-descriptions-item label="患者图片资料">
              <div v-if="item.medicalPhoto && item.medicalPhoto.length > 0">
                <el-image
                  v-for="(photo, photoIndex) in item.medicalPhoto"
                  :key="photoIndex"
                  :src="photo"
                  :preview-src-list="item.medicalPhoto"
                  style="width: 100px; height: 100px; margin-right: 10px"
                />
              </div>
              <span v-else>暂无患者图片资料</span>
            </el-descriptions-item>

            <el-descriptions-item label="转科情况">
              <div style="color: blueviolet">
                原科室:{{ item.originalDepartment }}--原医生:{{
                  item.originalDoctor
                }}
              </div>
              <div style="color: coral">
                新科室:{{ item.referraldepartment }}--新医生:{{
                  item.referraldoctorName
                }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="已拒绝" name="rejected">
          <div v-if="rejectedData.length === 0">
            <el-empty description="暂无已拒绝记录" />
          </div>
          <el-descriptions
            v-for="(item, index) in rejectedData"
            :key="index"
            border
            v-else
            direction="vertical"
            :column="2"
            style="margin-bottom: 20px"
          >
            <el-descriptions-item label="患者姓名">{{
              item.patientname
            }}</el-descriptions-item>
            <el-descriptions-item label="患者电话">
              <a :href="`tel:${item.patientphone}`">{{ item.patientphone }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="诊断信息">{{
              item.diagnosis.join(", ")
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医院">{{
              item.hospital
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊科室">{{
              item.keshi
            }}</el-descriptions-item>
            <el-descriptions-item label="转诊医生">{{
              item.name
            }}</el-descriptions-item>
            <el-descriptions-item label="医生电话">
              <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
            </el-descriptions-item>

            <el-descriptions-item label="患者图片资料">
              <div v-if="item.medicalPhoto && item.medicalPhoto.length > 0">
                <el-image
                  v-for="(photo, photoIndex) in item.medicalPhoto"
                  :key="photoIndex"
                  :src="photo"
                  :preview-src-list="item.medicalPhoto"
                  style="width: 100px; height: 100px; margin-right: 10px"
                />
              </div>
              <span v-else>暂无患者图片资料</span>
            </el-descriptions-item>

            <el-descriptions-item label="拒绝原因">{{
              item.rejectReason
            }}</el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

  <!-- 拒绝内容... -->
  <el-dialog
    v-model="rejectDialogVisible"
    title="拒绝接诊"
    width="80%"
    :before-close="handleClose"
  >
    <el-input
      v-model="rejectReason"
      type="textarea"
      placeholder="请输入拒绝原因"
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRejectConfirm">确认</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog
    v-model="transferDialogVisible"
    title="接诊转科"
    width="80%"
    :before-close="handleTransferClose"
  >
    <el-form :model="transferForm" label-width="80px">
      <el-form-item
        label="科室"
        :rules="[
          { required: true, message: '请选择科室', trigger: 'change' },
          { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
        ]"
      >
        <el-select
          v-model="transferForm.department"
          placeholder="请选择科室"
          filterable
          allow-create
          default-first-option
          :reserve-keyword="false"
        >
          <el-option
            v-for="keshi in keshis"
            :key="keshi.value"
            :label="keshi.label"
            :value="keshi.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="医生选择">
        <el-select
          v-model="transferForm.doctor"
          placeholder="请选择医生"
          filterable
          allow-create
          default-first-option
          :reserve-keyword="false"
        >
          <el-option
            v-for="doctor in doctorList"
            :key="doctor.id"
            :label="doctor.name"
            :value="doctor.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="transferDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleTransferConfirm"
          >确认</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  getsealosdata,
  dealsealosdata,
  jzzksealosdata,
} from "../../api/GetSeaos";
import { keshis } from "./keshis";
const router = useRouter();
const route = useRoute();

const data = ref([]);

const userInfo = ref({
  hospital: "",
  keshi: "",
  name: "",
  sex: "",
  zhicheng: "",
  phone: "",
  password: "",
  newpassword: "",
});

const activeTab = ref("pending");
const rejectDialogVisible = ref(false);
const rejectReason = ref("");
const currentRejectItem = ref(null);

const transferDialogVisible = ref(false);
const transferForm = ref({
  department: "",
  doctor: "",
});

const currentTransferItem = ref(null);
const doctorList = ref([
  { id: "1", name: "吴龙祥" },
  { id: "2", name: "薛秋" },
  { id: "3", name: "骆臣" },
]);

const rolevalue = ref("");
const rolesoptions = [
  {
    value: "接诊医生",
    label: "接诊医生",
  },
  {
    value: "转诊医生",
    label: "转诊医生",
  },
];

const pendingData = computed(() =>
  data.value.filter(
    (item) =>
      item.status === "待接诊" &&
      item.referraldepartment === userInfo.value.keshi &&
      item.referraldoctorName === userInfo.value.name
  )
);
const acceptedData = computed(() =>
  data.value.filter((item) => item.status === "已接诊")
);
const transferredData = computed(() =>
  data.value.filter(
    (item) =>
      item.oldstatus === "已转科" &&
      item.originalDepartment === userInfo.value.keshi &&
      item.originalDoctor === userInfo.value.name
  )
);
const rejectedData = computed(() =>
  data.value.filter((item) => item.status === "已拒绝")
);

onMounted(async () => {
  try {
    console.log("route.query", route.query);

    Object.assign(userInfo.value, route.query);
    const { name, keshi, hospital, role } = userInfo.value;

    // 根据角色设置默认的 activeTab
    if (role === "转诊医生") {
      activeTab.value = "referral"; // 假设 'referral' 是显示转诊记录的标签
    } else if (role === "接诊医生") {
      activeTab.value = "pending"; // 'pending' 是显示待接诊记录的标签
    }
    const res = await getsealosdata(name, keshi, hospital, role);
    data.value = res.data;
    console.log("医生主页", data.value);
  } catch (error) {
    console.error("获取信息时出错:", error);
  }
});

const startReferral = () => {
  router.replace({
    path: "/referral-patient",
    query: userInfo.value,
  });
};

const changerole = async (v) => {
  console.log("转换角色", v);
  userInfo.value.role = v;

  const { name, keshi, hospital, role } = userInfo.value;

  if (role === "转诊医生") {
    activeTab.value = "referral"; // 假设 'referral' 是显示转诊记录的标签
  } else if (role === "接诊医生") {
    activeTab.value = "pending"; // 'pending' 是显示待接诊记录的标签
  }
  const res = await getsealosdata(name, keshi, hospital, role);
  data.value = res.data;
};

const logout = () => {
  //localStorage.removeItem('token');
  router.replace({ name: "DoctorRegister" });
};

const goBack = () => {
  router.go(-1);
};

const updateStatus = async (id, status, rejectReason) => {
  try {
    const response = await dealsealosdata(id, status, rejectReason);
    console.log("状态更新成功", response.data);

    // 更新本地数据
    const index = data.value.findIndex((item) => item._id === id);
    if (index !== -1) {
      data.value[index].status = status;

      if (status === "已拒绝") {
        data.value[index].rejectReason = rejectReason;
      }
    }
  } catch (error) {
    console.error("状态更新失败:", error);
  }
};
const confirmReferral = async (item) => {
  console.log("确认接诊", item);
  await updateStatus(item._id, "已接诊");
};

const transferReferral = (item) => {
  console.log("接诊转科", item);
  currentTransferItem.value = item;
  transferDialogVisible.value = true;
};

const handleTransferConfirm = async () => {
  if (
    transferForm.value.department.trim() === "" ||
    transferForm.value.doctor.trim() === ""
  ) {
    alert("科室名称和医生选择不能为空");
    return;
  }

  try {
    const selectedDoctor = doctorList.value.find(
      (doctor) => doctor.id === transferForm.value.doctor
    );

    const { name, keshi, hospital, role } = userInfo.value;
    await updateTransferStatus(
      currentTransferItem.value._id,
      "待接诊",
      transferForm.value.department,
      selectedDoctor.name,
      keshi,
      name,
      "已转科"
    );
    console.log("接诊转科", currentTransferItem.value);
    transferDialogVisible.value = false;
    transferForm.value = { department: "", doctor: "" }; // 清空表单

    //const { name, keshi, hospital, role } = userInfo.value;
    const res = await getsealosdata(name, keshi, hospital, role);
    data.value = res.data;
  } catch (error) {
    console.error("接诊转科失败:", error);
  }
};

const updateTransferStatus = async (
  id,
  status,
  department,
  doctorName,
  originalDepartment,
  originalDoctor,
  oldstatus
) => {
  try {
    const response = await jzzksealosdata(
      id,
      status,
      department,
      doctorName,
      originalDepartment,
      originalDoctor,
      oldstatus
    );
    console.log("状态更新成功", response.data);

    // 更新本地数据
    const index = data.value.findIndex((item) => item._id === id);
    if (index !== -1) {
      data.value[index].status = status;
      data.value[index].referraldepartment = department;
      data.value[index].referraldoctorName = doctorName;

      // 记录转科前的科室和医生
      //data.value[index].originalDepartment = data.value[index].referraldepartment;
      //data.value[index].originalDoctor = data.value[index].referraldoctorName;
    }
  } catch (error) {
    console.error("状态更新失败:", error);
  }
};

const handleTransferClose = (done) => {
  transferForm.value = { department: "", doctor: "" }; // 清空表单
  done();
};

const handleRejectConfirm = async () => {
  if (rejectReason.value.trim() === "") {
    alert("拒绝原因不能为空");
    return;
  }

  try {
    await updateStatus(
      currentRejectItem.value._id,
      "已拒绝",
      rejectReason.value
    );
    console.log("拒绝接诊", currentRejectItem.value);
    rejectDialogVisible.value = false;
    rejectReason.value = ""; // 清空输入框
  } catch (error) {
    console.error("拒绝接诊失败:", error);
  }
};

const handleClose = (done) => {
  rejectReason.value = ""; // 清空输入框
  done();
};

const rejectReferral = async (item) => {
  currentRejectItem.value = item;
  rejectDialogVisible.value = true;
  // console.log("拒绝接诊", item);

  // try {
  //   const rejectReason = prompt("请输入拒绝原因：");
  //   if (rejectReason === null || rejectReason.trim() === "") {
  //     alert("拒绝原因不能为空");
  //     return;
  //   }

  //   await updateStatus(item._id, "已拒绝", rejectReason);
  //   console.log("拒绝接诊", item);
  // } catch (error) {
  //   console.error("拒绝接诊失败:", error);
  // }
  //await updateStatus(item._id, "已拒绝");
};
</script>
